export {deleteComponent} from './deleteComponent'
